export default __webpack_public_path__ + "static/media/eleventy-white.0e3c8c75.svg";